import { LegalShell, LegalSection, LegalList } from "@/components/site/LegalShell";

export default function TermsOfUse() {
  return (
    <LegalShell
      title="Terms of Use"
      updated="June 2026"
      seoTitle="Terms of Use | AYOBELL"
      seoDesc="The terms governing your use of the AYOBELL marketing website (ayobell.com)."
    >
      <LegalSection>
        <p>These Terms of Use govern your use of the AYOBELL marketing website at ayobell.com, operated by TechSpace Solutions Ltd. By using this website you agree to these terms. Use of the AYOBELL care management application is governed by separate agreements.</p>
      </LegalSection>

      <LegalSection heading="Use of this website">
        <LegalList items={[
          "You may use this website for lawful purposes and to learn about AYOBELL.",
          "You must not misuse the site, attempt to gain unauthorised access, or disrupt its operation.",
          "Content on this website is provided for general information about AYOBELL and does not constitute a contractual offer.",
        ]} />
      </LegalSection>

      <LegalSection heading="Intellectual property">
        <p>The AYOBELL name, logo, branding and the content of this website are owned by or licensed to TechSpace Solutions Ltd and may not be reproduced without permission. Product screens shown on this website are illustrative.</p>
      </LegalSection>

      <LegalSection heading="No warranties">
        <p>This website is provided "as is". While we aim to keep information accurate and up to date, we make no warranties about its completeness or availability, and product functionality described here may evolve.</p>
      </LegalSection>

      <LegalSection heading="Limitation of liability">
        <p>To the extent permitted by law, TechSpace Solutions Ltd is not liable for any loss arising from your use of this marketing website.</p>
      </LegalSection>

      <LegalSection heading="Governing law">
        <p>The governing law and jurisdiction applicable to your relationship with TechSpace Solutions Ltd are set out in the relevant agreement between you and TechSpace Solutions Ltd.</p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>Questions about these terms can be sent to <a className="text-teal-700 font-semibold" href="mailto:info@ayobell.com">info@ayobell.com</a>.</p>
      </LegalSection>
    </LegalShell>
  );
}
